/*
 * @Description: 接收任务
 * @Date: 2025-05-22 18:45:35
 */
import { route } from './src/router';

const name = 'receive-task';
export { name, route };
